import user from './modules/user'
import common from './modules/common'
import dashboard from './modules/dashboard'
import dongti from './modules/dongti'

export default {
  user,
  common,
  dashboard,
  dongti
}
